import { configureStore } from "@reduxjs/toolkit";
import navReducer from "./features/nav/navSlice";
import addJobReducer from "./features/addJob/addJobSlice";
import allJobsReducer from "./features/allJobs/allJobsSlice";
import editJobReducer from "./features/allJobs/editSlice";
import profileReducer from "./features/profile/profileSlice";
import loginReducer from "./features/registration/loginSlice";
import regReducer from "./features/registration/registerSlice";
import contactReducer from "./features/contact/contactSlice";
import deleteReducer from "./features/allJobs/deleteJobSlice";
import statReducer from "./features/stat/statSlice";
import postJobReducer from "./features/postJob/postJobSlice";
import allPostJobsReducer from "./features/postJob/getAllPostJobsSlice";
import singlePostJobReducer from "./features/postJob/singlePostJob";
import saveForLaterReducer from "./features/saveForLater/saveForLaterSlice";
import createSaveForLaterReducer from "./features/saveForLater/createSaveLateSlice";
import generalReducer from "./features/general/generalSlice";

export const store = configureStore({
  reducer: {
    navStore: navReducer,
    addJobStore: addJobReducer,
    allJobsStore: allJobsReducer,
    editJobStore: editJobReducer,
    profileStore: profileReducer,
    loginStore: loginReducer,
    regStore: regReducer,
    contactStore: contactReducer,
    deleteStore: deleteReducer,
    statStore: statReducer,
    postJobStore: postJobReducer,
    allPostJobsStore: allPostJobsReducer,
    singlePostJobStore: singlePostJobReducer,
    saveForLaterStore: saveForLaterReducer,
    createSaveForLaterStore: createSaveForLaterReducer,
    generalStore: generalReducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
